import { creatorbase, YoutubeInfluencerPostPatchErrorData } from '@round/api';
import { PaymentInfo } from 'Modules/Advertising/InfluencerPlan/InfluencerPlan.api';
import { FormValues } from 'Modules/Plans/Project/ProjectDetails/Posts/PostPaymentRequestModal/helpers';
import { mapApiErrorsToFormikErrors } from 'utility/utility';
import { InstagramPatchErrorData } from '../../api/Instagram.api';
import { TiktokPatchErrorData } from '../../api/Tiktok.api';
import { FormikErrors } from 'formik';

// Helpers for using the creatorbase payment request modal in round influencer post tables.
// Mainly for mapping form values with round post patching handlers

// The payment-related patch data common to all platform posts.with
export type PaymentDetailsPatchData = {
    base_cost: string | undefined;
    currency_id: number | undefined;
    payment_info: PaymentInfo | undefined;
    payment_request_file_upload: File | '' | undefined;
};

export const mapFormValuesToPatchData = (values: FormValues, feeConfigs?: creatorbase.ClientProviderFeeConfig[]) => {
    const provider = values.provider;
    return {
        base_cost: values.cost?.toString(),
        currency_id: values.currency?.value,
        payment_info: {
            paypal_email_address: provider === 'PAYPAL' ? values.paypalEmail : undefined,
            client_payee_id: provider === 'TIPALTI' ? values.payee?.value : undefined,
            fee_config_id: feeConfigs?.find((feeConfig) => feeConfig.provider_name === values.provider)
                ?.provider_fee_config_id,
            creator_agency_payee_id: provider === 'CREATOR_AGENCY' ? values.agencyPayee?.value : undefined,
            notes: values.notes,
        },
        payment_request_file_upload: values.fileUpload,
    };
};

export const mapPatchErrorResponseToFormErrors = (
    errorData: InstagramPatchErrorData | TiktokPatchErrorData | YoutubeInfluencerPostPatchErrorData
): FormikErrors<FormValues> =>
    mapApiErrorsToFormikErrors({
        cost: errorData.base_cost,
        currency: errorData.currency_id,
        provider: errorData.fee_config_id,
    });
